
import { getQueryUrl } from "../util/getQueryUrl.js";
const tmBdXToken = () => {
  const sourceForm = getQueryUrl('from') || 'h5';
  const sourceToken = getQueryUrl('token') || '';
  if (sourceForm === 'tmBd' && sourceToken) {
    return sourceToken;
  }
  return false;
}
export {
  // eslint-disable-next-line import/prefer-default-export
  tmBdXToken,
}